import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { BasketView } from 'ish-core/models/basket/basket.model';
import { HttpError } from 'ish-core/models/http-error/http-error.model';

/**
 * The Shopping Basket Component displays the users basket items, cost summary
 * and promotion code input.
 * It provides update cart and add cart to quote functionality.
 * It is the starting point for the checkout workflow.
 *
 * It uses the {@link LineItemListComponent} for the rendering of line items.
 * It uses the {@link BasketCostSummaryComponent} to render the cost summary.
 * It uses the {@link BasketPromotionCodeComponent} to render the promotion code input.
 *
 * @example
 * <ish-shopping-basket
 *   [basket]="basket"
 *   [error]="basketError$ | async"
 *   (nextStep)="nextStep()"
 * ></ish-shopping-basket>
 */
@Component({
  selector: 'ish-shopping-basket',
  templateUrl: './shopping-basket.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ShoppingBasketComponent {
  readonly basket = input.required<BasketView>();
  readonly error = input<HttpError>(undefined);
  readonly loading = input(false);

  readonly nextStep = output<void>();

  /**
   * checkout button leads to checkout address page if basket is valid
   */
  checkout() {
    // TODO: The 'emit' function requires a mandatory void argument
    this.nextStep.emit();
  }
}
